var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"fill-button",class:_vm.customClasses},[_vm._t("default"),(_vm.hasIcon)?_c('span',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.displayArrowIcon())}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }